import getFullConfigFromBrandConfig from './base';
import wintradoStagingConfig from './wintrado.staging';
const config = getFullConfigFromBrandConfig(wintradoStagingConfig, 'staging');
export default config;
